import { useEffect } from "react";
import { Form, Input, Switch, Tooltip } from "antd";
import { t } from "i18next";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import "../../../core/components/quick-filter/quick-filter.css";

/**
 * Hasta listesi filtresi — randevu listesindeki çubukla aynı düzen: arama kartı + doğrulanmış anahtarı.
 * Arama hasta alanlarında (ad, kimlik, telefon, e-posta, not) çalışır; Enter / büyüteç / çarpı ile uygulanır.
 */
export default function PatientFilter() {
    const { onFilterPageSort, queryModel } = useDataGrid();
    const [form] = Form.useForm();
    const searchText = Form.useWatch('searchText', form) || '';

    useEffect(() => {
        form.setFieldsValue({
            validate: true,
            ...queryModel.filter,
        });
    }, [queryModel.updateKey]);

    const onFinish = (formData) => {
        onFilterPageSort({
            filter: formData
        })
    }

    return (
        <Form
            form={form}
            size="small"
            onFinish={onFinish}
            initialValues={{ validate: true }}
        >
            <div className="qf-row qf-row-top">
                <Tooltip title={t('Name, Id, Phone ...')} mouseEnterDelay={0.6} placement="bottomLeft">
                    <div className={`qf-search${searchText.trim() ? ' is-active' : ''}`}>
                        <Form.Item name="searchText" noStyle>
                            <Input.Search
                                size="small"
                                allowClear
                                placeholder={t('Type anything: name, ID, number, note...')}
                                // Enter formu zaten gönderiyor (tek metin kutusu → native submit); burada yalnız ikon ve çarpı.
                                onSearch={(value, e) => {
                                    if (e?.type !== 'keydown') form.submit()
                                }}
                            />
                        </Form.Item>
                    </div>
                </Tooltip>

                <div className="qf-group">
                    <label className="appt-grid-toggles__switch">
                        <Form.Item name="validate" valuePropName="checked" noStyle>
                            <Switch size="small" onChange={() => form.submit()} />
                        </Form.Item>
                        <span>{t('Verified Patients')}</span>
                    </label>
                </div>
            </div>
        </Form>
    )
}
